import { FormControl, Input } from '@airbus/components-react';

type BulkUpdateStringInputProps = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  disabled?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  maxLength?: number;
};

export default function BulkUpdateStringInput({
  id,
  value,
  onChange,
  onBlur,
  disabled = false,
  hasError = false,
  errorMessage,
  maxLength,
}: BulkUpdateStringInputProps) {
  return (
    <FormControl
      id={id}
      disabled={disabled}
      error={hasError || Boolean(errorMessage)}
      helpText={errorMessage || undefined}
      errorText={errorMessage || undefined}
      className='input-small disabled-input'
    >
      <Input
        name={id}
        size='small'
        value={value}
        readOnly={disabled}
        maxLength={maxLength}
        onChange={(event) => onChange(event.target.value)}
        onBlur={onBlur}
      />
    </FormControl>
  );
}
